import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailThreadPreviewComponent } from 'components/queue-view/queue-view-tab/work-item-preview/email-thread-preview/email-thread-preview.component';
import { EmailViewerModule } from 'shared/components/email-viewer/email-viewer.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';

@NgModule({
  imports: [
    CommonModule,
    EmailViewerModule,
    LoadingModule,
    WorkWidgetHeaderModule,
    VisitorHistoryModule
  ],
  declarations: [
    EmailThreadPreviewComponent
  ],
  exports: [
    EmailThreadPreviewComponent
  ]
})
export class EmailThreadPreviewModule {}
